<app-card title="">
  <div title class="inventory_ctrl flex flex-row items-center justify-between">
    <h5 class="ucase m-0 text-primaryblue">FORMULARY TOOL V4.7.0</h5>
  </div>

  <section class="landing-content">
    <div class="filter-toolbar">
      <div class="customer-search">
        <div class="customer-search-control">
          <div class="customer-search-input-section">
            <app-icon icon="search" class="icon_search"></app-icon>
            <input
              appNoHtmlTags
              class="customer-search-input"
              inputId="searchcustomers-input"
              (ngModelChange)="onSearchInput($event)"
              [placeholder]="'Search by ' + selectedSearchCriteria.label"
              [ngModel]="searchText"
              id="search_customers">
            <app-icon
              icon="clear"
              *ngIf="searchText"
              (click)="onSearchInput('')"
              id="data-clear"
              class="pointer"></app-icon>
          </div>
          <div class="customer-search-separator"></div>
          <button
            mat-button
            type="button"
            class="customer-search-criteria"
            [matMenuTriggerFor]="customerSearchMenu">
            {{selectedSearchCriteria.label}}
            <mat-icon>expand_more</mat-icon>
          </button>
        </div>
        <div *ngIf="validationError" class="customer-search-error" role="alert">
          {{validationError}}
        </div>

        <mat-menu #customerSearchMenu="matMenu" panelClass="customer-search-menu" xPosition="after">
          <button mat-menu-item *ngFor="let criteria of searchCriteria" (click)="onSearchCriteriaChange(criteria.value)">
            {{criteria.label}}
          </button>
        </mat-menu>
      </div>

      <div class="filter-control">
        <label for="project-status">Project Status</label>
        <mat-form-field floatLabel="never" subscriptSizing="dynamic">
          <mat-select id="project-status" [value]="selectedProjectStatus" (selectionChange)="doFilter($event.value, false, selectedProduct)">
            <mat-option *ngFor="let status of projectStatus" [value]="status.id">{{status.value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="filter-control">
        <label for="salesforce-status">Salesforce Status</label>
        <mat-form-field floatLabel="never" subscriptSizing="dynamic">
          <mat-select id="salesforce-status" [formControl]="salesforceStatus" multiple placeholder="All">
            <mat-option *ngFor="let status of salesforceStatusList" [value]="status.value">{{status.key}}</mat-option>
          </mat-select>
        </mat-form-field>
        <button
          id="btn_load_data"
          class="btn-blue btn-sm"
          *ngIf="salesforceStatus.value?.length > 0"
          (click)="currentPage = 0; getCustomerData()">Load</button>
      </div>

      <div class="filter-control product-filter">
        <label for="salesforce-product">Salesforce Product</label>
        <mat-form-field floatLabel="never" subscriptSizing="dynamic">
          <mat-select id="salesforce-product" [value]="selectedProduct" (selectionChange)="doFilter(statusId, false, $event.value)">
            <mat-option *ngFor="let value of Products" [value]="value">{{value}}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <div class="account-table-wrap">
      <table mat-table [dataSource]="dataSource" [trackBy]="trackRow" matSort (matSortChange)="sortChange($event)">
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row">
            <button
              *ngIf="!row.record"
              mat-icon-button
              class="expand-button"
              [attr.aria-label]="row.account.expanded ? 'Collapse account' : 'Expand account'"
              (click)="toggleAccount(row.account)">
              <mat-icon>{{row.account.expanded ? 'expand_more' : 'chevron_right'}}</mat-icon>
            </button>
          </td>
        </ng-container>

        <ng-container matColumnDef="customerName">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Customer Name</th>
          <td mat-cell *matCellDef="let row">
            <span *ngIf="!row.record" class="account-name">
              <mat-icon class="account-icon" aria-hidden="true">business</mat-icon>
              <strong>{{row.account.customerName}}</strong>
            </span>
            <span *ngIf="row.record as record" class="asset-selection">
              <mat-checkbox
                [checked]="isImplementationSelected(record)"
                [aria-label]="'Select asset ' + (record.assetNumber || record.customerId)"
                (change)="setImplementationSelected(record, $event.checked)">
              </mat-checkbox>
              <span class="asset-number">{{record.assetNumber || ''}}</span>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="caseCount">
          <th mat-header-cell *matHeaderCellDef>Cases</th>
          <td mat-cell *matCellDef="let row">
            <ng-container *ngIf="row.record as record; else accountCaseCount">
              <a *ngIf="record.caseDetailsLink; else plainCaseNumber" [href]="record.caseDetailsLink" target="_blank" rel="noopener noreferrer">{{record.caseNumber}}</a>
              <ng-template #plainCaseNumber>{{record.caseNumber}}</ng-template>
            </ng-container>
            <ng-template #accountCaseCount>{{row.account.caseCount}}</ng-template>
          </td>
        </ng-container>

        <ng-container matColumnDef="subDeviceTypeName">
          <th mat-header-cell *matHeaderCellDef>Devices</th>
          <td mat-cell *matCellDef="let row">
            {{row.record ? row.record.subDeviceTypeName : row.account.deviceCount}}
          </td>
        </ng-container>

        <ng-container matColumnDef="lastEdited">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Last Edited</th>
          <td mat-cell *matCellDef="let row">{{(row.record || row.account.latestRecord).lastEdited}}</td>
        </ng-container>

        <ng-container matColumnDef="statusDescription">
          <th mat-header-cell *matHeaderCellDef>Status</th>
          <td mat-cell *matCellDef="let row">
            <span
              *ngIf="row.record"
              class="status-badge"
              [ngClass]="getStatusClass(row.record.statusDescription)">
              {{row.record.statusDescription}}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="salesforceStatus">
          <th mat-header-cell *matHeaderCellDef>Salesforce Status</th>
          <td mat-cell *matCellDef="let row">{{getSalesforceStatusLabel(row.record?.salesforceStatus)}}</td>
        </ng-container>

        <ng-container matColumnDef="targetInstallDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Target Install Date</th>
          <td mat-cell *matCellDef="let row">{{row.record?.targetInstallDateDisplay}}</td>
        </ng-container>

        <ng-container matColumnDef="owner">
          <th mat-header-cell *matHeaderCellDef>Last Modified By</th>
          <td mat-cell *matCellDef="let row">{{(row.record || row.account.latestRecord).owner}}</td>
        </ng-container>

        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let row" class="action-cell">
            <span class="action-trigger" matTooltipClass="multi-max-action-tooltip" [matTooltip]="!row.record && !canOpenAccountActions(row.account) ? 'Select at least one device to enable actions' : ''" [attr.tabindex]="!row.record && !canOpenAccountActions(row.account) ? 0 : null">
            <button mat-icon-button [disabled]="!row.record && !canOpenAccountActions(row.account)" [matMenuTriggerFor]="rowActions" [matMenuTriggerData]="{ record: getActionRecord(row) }" aria-label="Implementation actions">
              <svg class="action-dots" width="24" height="24" viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="currentColor">
                <circle cx="5" cy="12" r="2"></circle>
                <circle cx="12" cy="12" r="2"></circle>
                <circle cx="19" cy="12" r="2"></circle>
              </svg>
            </button>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
        <tr mat-row class="account-row" *matRowDef="let row; columns: displayedColumns; when: isAccountRow"></tr>
        <tr mat-row class="implementation-row" *matRowDef="let row; columns: displayedColumns; when: isImplementationRow"></tr>
        <tr *matNoDataRow>
          <td class="empty-state" [attr.colspan]="displayedColumns.length">No Records Found!</td>
        </tr>
      </table>
      <mat-menu #rowActions="matMenu" backdropClass="custom_drop" xPosition="before">
        <ng-template matMenuContent let-record="record">
          <button mat-menu-item (click)="openAddSite(record)">Edit Import File</button>
          <button mat-menu-item [disabled]="!canExport(record)" (click)="redirectPageBasedOnStatus(record)">Export</button>
          <button mat-menu-item (click)="openAlertWindow(record)">Remove</button>
        </ng-template>
      </mat-menu>
    </div>

    <footer class="table-footer">
      <span>Showing {{totalRows ? currentPage * pageSize + 1 : 0}} to {{visibleEnd}} of {{totalRows}} customers</span>
      <div class="pagination-controls" aria-label="Customer pagination">
        <select id="customer-page-size" aria-label="Customers per page" [ngModel]="pageSize" (ngModelChange)="setPageSize($event)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{size}} per page</option>
        </select>
        <nav class="page-buttons" aria-label="Pages">
          <button type="button" class="page-arrow" aria-label="First page" [disabled]="currentPage === 0" (click)="setPage(0)">&laquo;</button>
          <button type="button" class="page-arrow" aria-label="Previous page" [disabled]="currentPage === 0" (click)="setPage(currentPage - 1)">&lsaquo;</button>
          <button
            *ngFor="let page of pageNumbers"
            type="button"
            [attr.aria-label]="'Page ' + (page + 1)"
            [attr.aria-current]="page === currentPage ? 'page' : null"
            [class.active]="page === currentPage"
            (click)="setPage(page)">{{page + 1}}</button>
          <button type="button" class="page-arrow" aria-label="Next page" [disabled]="currentPage >= totalPages - 1" (click)="setPage(currentPage + 1)">&rsaquo;</button>
          <button type="button" class="page-arrow" aria-label="Last page" [disabled]="currentPage >= totalPages - 1" (click)="setPage(totalPages - 1)">&raquo;</button>
        </nav>
      </div>
      <button type="button" class="next-button" [disabled]="!hasSelectedImplementations" (click)="openSelectedImplementation()">Next</button>
    </footer>
  </section>
</app-card>
